import { User } from "./SDKUser";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- -- - --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class UserMembership {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.user = new User(model.user);
        this.role = model.role;
        this.effectiveRole = model.effectiveRole;
        this.seatType = model.seatType;
        this.effectiveSeatType = model.effectiveSeatType;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    /** Constructs representation that can be used to write full object to remote */
    toRemote() {
        return {
            user: this.user.toRemote(),
            role: this.role,
            effectiveRole: this.effectiveRole,
            seatType: this.seatType,
            effectiveSeatType: this.effectiveSeatType,
        };
    }
}
